import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search } from "lucide-react";
import DatePickerInput from "@/components/DatePickerInput";
import { ACTION_LABELS } from "./constants";

const PRESETS = [
  { key: "today", label: "Hari Ini" },
  { key: "yesterday", label: "Kemarin" },
  { key: "this_week", label: "Minggu Ini" },
  { key: "this_month", label: "Bulan Ini" },
];

export const HistoryFilterBar = ({
  search, setSearch,
  action, setAction,
  actorId, setActorId,
  startDate, setStartDate,
  endDate, setEndDate,
  filterOptions,
  totalCount,
  onApply,
  onReset,
  onPreset,
}) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        <div>
          <Label className="text-gray-300 mb-2 block text-sm">Cari (member / catatan)</Label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
            <Input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Ketik untuk cari..."
              className="pl-9 bg-[#0f0f10] border-red-900/30 text-white"
              data-testid="history-search"
            />
          </div>
        </div>
        <div>
          <Label className="text-gray-300 mb-2 block text-sm">Aksi</Label>
          <Select value={action} onValueChange={setAction}>
            <SelectTrigger className="bg-[#0f0f10] border-red-900/30 text-white" data-testid="history-action-filter">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#1a1a1b] border-red-900/30 text-white">
              <SelectItem value="all">Semua Aksi</SelectItem>
              {(filterOptions.actions || []).map((a) => (
                <SelectItem key={a} value={a}>{ACTION_LABELS[a] || a}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className="text-gray-300 mb-2 block text-sm">User</Label>
          <Select value={actorId} onValueChange={setActorId}>
            <SelectTrigger className="bg-[#0f0f10] border-red-900/30 text-white" data-testid="history-actor-filter">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#1a1a1b] border-red-900/30 text-white">
              <SelectItem value="all">Semua User</SelectItem>
              {(filterOptions.actors || []).map((a) => (
                <SelectItem key={a.id} value={a.id}>{a.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div />
        <div>
          <Label className="text-gray-300 mb-2 block text-sm">Dari Tanggal</Label>
          <DatePickerInput
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="bg-[#0f0f10] border-red-900/30 text-white"
            data-testid="history-start-date"
          />
        </div>
        <div>
          <Label className="text-gray-300 mb-2 block text-sm">Sampai Tanggal</Label>
          <DatePickerInput
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="bg-[#0f0f10] border-red-900/30 text-white"
            data-testid="history-end-date"
          />
        </div>
      </div>

      <div>
        <Label className="text-gray-300 mb-2 block text-sm">Preset Tanggal</Label>
        <div className="flex flex-wrap gap-2">
          {PRESETS.map((p) => (
            <Button
              key={p.key}
              onClick={() => onPreset(p.key)}
              variant="outline"
              size="sm"
              className="border-red-900/30 text-white hover:bg-red-900/20"
            >
              {p.label}
            </Button>
          ))}
        </div>
      </div>

      <div className="flex gap-2">
        <Button onClick={onApply} className="bg-red-600 hover:bg-red-700 text-white" data-testid="history-apply-btn">
          <Search size={16} className="mr-2" /> Terapkan Filter
        </Button>
        <Button onClick={onReset} variant="outline" className="border-red-900/30 text-white hover:bg-red-900/20" data-testid="history-reset-btn">
          Reset
        </Button>
        <div className="ml-auto text-sm text-gray-400 self-center">
          Total: <span className="text-red-300 font-semibold">{totalCount}</span> entri
        </div>
      </div>
    </>
  );
};

export default HistoryFilterBar;
